/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import {
	DndContext,
	PointerSensor,
	useSensor,
	useSensors,
	closestCenter,
	MouseSensor,
	TouchSensor
} from "@dnd-kit/core";
import {
	SortableContext,
	useSortable,
	arrayMove,
	verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import MDBox from "components/Basics/MDBox";
import TextDetails from "../TextDetails";
import { t } from "i18next";

/**
 * Item component for the sortable list in the DnD context
 * @param {*} param0
 * @returns
 */
const SortableItem = ({ item, index, knowledge }) => {
	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
		id: item
	});

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		background: "#fff",
		border: "1px solid #ccc",
		borderRadius: "4px",
		cursor: "grab"
	};

	return (
		<MDBox p={1} mb={1} ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<TextDetails
				text={knowledge?.content || t("FAIQ.ACTIONS.noContent")}
				minHeight="10vh"
				fontSize="0.8rem"
			/>
		</MDBox>
	);
};

const MergeKnowledgeDnd = ({ items, onChange, knowledges }) => {
	/**
	 * Re emit the event to the parent component
	 */
	const sensors = useSensors(
		useSensor(MouseSensor, {
			onActivation: e => {
				e.event.target.click();
			}
		}),
		useSensor(TouchSensor, {
			onActivation: e => {
				e.event.target.click();
			}
		}),
		useSensor(PointerSensor, {
			onActivation: e => {
				e.event.target.click();
			}
		})
	);

	// Handle drag end event
	const handleDragEnd = event => {
		const { active, over } = event;
		if (!over || active.id === over.id) return;

		const oldIndex = items.findIndex(item => item === active.id);
		const newIndex = items.findIndex(item => item === over.id);

		const newList = arrayMove(items, oldIndex, newIndex);
		onChange(newList);
	};

	return (
		<MDBox m={1}>
			<DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
				<SortableContext items={items} strategy={verticalListSortingStrategy}>
					{items.map((item, index) => {
						const knowledge = knowledges.find(k => k.uuid === item);
						return <SortableItem key={item} item={item} knowledge={knowledge} index={index} />;
					})}
				</SortableContext>
			</DndContext>
		</MDBox>
	);
};

export default MergeKnowledgeDnd;
